var _style, _path, _path2, _path3, _polyline, _path4, _path5, _path6, _path7, _g, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLogo = props => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 60 60",
  style: {
    enableBackground: "new 0 0 60 60"
  },
  xmlSpace: "preserve"
}, props), _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, ".st0{fill:none;stroke:#EE7163;stroke-width:3.5628;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st1{fill:none;stroke:#EE7163;stroke-width:3.5628;stroke-linecap:round;stroke-miterlimit:10;}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M1.83,45.69c0.43,6.12,6.04,11.09,12.6,11.35c1.9,0,12.03,0.18,14.01,0.15c7.78-0.15,12.05,0.31,19.83-0.37 c5.68-0.56,10.57-5.82,9.86-11.15c-4.39,0-8.67,0-13.03,0.02"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M45.1,45.69c-13.79-0.02-29.49-0.02-43.29,0"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M23.57,32.63c-5.83,0-11.67-0.02-17.51,0c-2.34,0.01-4.33,1.54-4.28,3.5c0.05,1.9,1.98,3.33,4.28,3.33 c7.9,0.02,15.81,0.01,23.7,0"
})), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
  className: "st1",
  points: "28.27,32.62 37.96,39.45 47.32,32.62 "
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M58.21,19.49H1.8C3.06,2.76,17.63,2.95,31.56,2.82C45.86,2.7,57.99,4.71,58.21,19.49c-18.8,0-37.61,0-56.41,0"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M46.65,39.43"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M55.24,39.33"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M52.95,34.85"
})), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M56.98,27.72c-2.99,0-5.99-2.61-8.99-2.61C45,25.11,42,27.72,39,27.72c-2.99,0-5.99-2.61-8.99-2.61 c-2.99,0-6,2.61-8.99,2.61s-6-2.61-8.99-2.61s-6,2.61-8.99,2.61"
}))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M52.14,32.62c5.83,0-4.01-0.01,1.82,0.01c2.34,0.01,4.33,1.54,4.28,3.5c-0.05,1.9-1.98,3.33-4.28,3.33 c-7.9,0.02,0.8-0.01-7.32-0.02"
})));
export { SvgLogo as ReactComponent };